import { ApolloLink, NextLink, Operation } from '@apollo/client'

// The backend reads the MFA token from this request header (Rack maps it to
// HTTP_MFA_TOKEN). Dashes are used rather than underscores so proxies don't drop it.
export const MFA_TOKEN_HEADER = 'MFA-TOKEN'
const MFA_TOKEN_STORAGE_KEY = 'mfaToken'

// The sign-in and MFA-challenge operations are whitelisted from the backend's
// MFA-token check, so there is nothing to attach for them.
const OPERATIONS_WITHOUT_MFA_TOKEN = [
  'signInUser',
  'signInThirdPartyUser',
  'sendMfaSmsCode',
  'verifyMfaSmsCode'
]

export const getMfaToken = () => localStorage.getItem(MFA_TOKEN_STORAGE_KEY)

export const setMfaToken = (token: string) => localStorage.setItem(MFA_TOKEN_STORAGE_KEY, token)

export const clearMfaToken = () => localStorage.removeItem(MFA_TOKEN_STORAGE_KEY)

class MfaTokenLink extends ApolloLink {
  request(operation: Operation, forward: NextLink) {
    operation.setContext((context: Record<string, any>) => {
      const { headers = {} } = context
      const token = getMfaToken()
      if (token && !OPERATIONS_WITHOUT_MFA_TOKEN.includes(operation.operationName)) {
        headers[MFA_TOKEN_HEADER] = token
      }

      return {
        headers
      }
    })
    return forward(operation)
  }
}

export const mfaTokenLink = new MfaTokenLink()
